module.exports = __webpack_public_path__ + "static/media/jbc-logo.7098a0e8.png";